import { useDatabase } from './DatabaseProvider'
// optional: import { useAppSelector } from '@/store/hooks'

export function UserNameDisplay({ showRole = true }: { showRole?: boolean }) {
  const { user } = useDatabase()

  if (user.loading) {
    return <span className="text-sm text-gray-500">Cargando...</span>
  }

  if (!user.isAuthenticated || !user.user) {
    return <span className="text-sm text-gray-700">Invitado</span>
  }

  const name = `${user.user.first_name ?? ''} ${user.user.last_name ?? ''}`.trim() || user.user.email
  const role = user.user.user_type === 'admin' ? 'Administrador' : 'Socio'

  return (
    <div>
      <div className="text-sm text-gray-900 font-medium truncate">{name}</div>
      {showRole && <div className="text-xs text-gray-500 truncate">{role}</div>}
    </div>
  )
}

export default UserNameDisplay